import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import NextAction from "../../utils/NextAction";

interface ContrlProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}
const texts = [
  `
  We introduce Cell Decomposition for motion planning here. You may have learned about path planning with Voronoi on the previous page and found that the Voronoi algorithm is quite complex.
To address this complexity, researchers have developed another method called Cell Decomposition. This method decomposes the map into several cells, each representing a node. These nodes can be connected to form a graph. Then, we can apply Dijkstra's and A* algorithms on the graph to find the optimal path.
Let's see how Cell Decomposition works.
  `,
  "First, we find all the vertices of the polygons.",
  "Draw a line upward from each vertex. Stop when it meets a boundary or another polygon.",
  "Then, draw a line downward from each vertex. Stop when it meets a boundary or another polygon.",
  "Annotate the nodes of each cell",
  "Annotate the nodes at the center of each cell boundary",
  `Connect the nodes on the boundary of each cell to the nodes at the center of the cell boundaries. This forms a graph!
  You can now use Dijkstra's or A* algorithm to find the optimal path. When you know your start point and target point, simply choose the node of the cell containing the point as the start node or target node`,
];

export default function Controls({ step, setStep }: ContrlProps) {
  return (
    <div className="controls">
      <div>
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Cell Decomposition
        </Typography>
        {step == 0 && (
          <Typography
            style={{
              paddingBottom: 10,
              textAlign: "left",
              whiteSpace: "pre-line",
            }}
          >
            {texts[step]}
          </Typography>
        )}
        {step != 0 && (
          <>
            <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
              Step {step}
            </Typography>
            <Typography
              sx={{ mb: 3, textAlign: "left", whiteSpace: "pre-line" }}
            >
              {texts[step]}
            </Typography>
          </>
        )}
        {step == 0 && (
          <Button
            variant={"contained"}
            sx={{ mb: 2 }}
            onClick={() => setStep(1)}
          >
            Start Tutorial
          </Button>
        )}
        {step != 0 && (
          <>
            <Button
              variant={"contained"}
              sx={{ mb: 2, mr: 4 }}
              onClick={() => setStep(step - 1)}
            >
              Previous
            </Button>
            {step !== 6 && (
              <Button
                variant={"contained"}
                sx={{ mb: 2 }}
                onClick={() => setStep(step + 1)}
              >
                Next
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
